/* eslint-disable max-len */
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useLoaderData, useSubmit } from "react-router-dom";
import { STRING_BOOLEAN } from "../../components/RootLayout/RootLayoutModels";
import { packObjForSubmit, unpackObjForSubmit } from "../../utils";
import { doFetch } from "../../utils/doFetch";
import { doFetchPut } from "../../utils/doFetchPut";
import { CurrentDispatch } from "./CurrentDispatch";
import { ICurrentDespatchData } from './CurrentDispatchData';

export const currentDispatchRouteLoader = async ({ request }: { request: any }) => {
  return doFetch(`my-dispatch`, { signal: request.signal }, true, true)
}

export const currentDispatchRouteAction = async ({ request }: { request: any, params: any }) => {
  let formData = await request.formData();
  let obj = JSON.parse(unpackObjForSubmit(formData));
  return doFetchPut(`my-dispatch-confirmation/${obj.id}`, { signal: request.signal });
}

export const CurrentDispatchRoute = () => {
  const data = useLoaderData() as ICurrentDespatchData;
  const submit = useSubmit();
  const auth = useAuth();
  const isTelephoneBoard = auth.user?.profile.isTelephoneBoard === STRING_BOOLEAN.true;
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  const msg = (
    <Box>
      <Typography sx={{ mb: 1 }}>
        Current dispatch information is real-time. This information may change at any time. Please check your work status frequently!
      </Typography>
      <Typography>
        Dispatch, callback, and other information displayed here are provided for informational purposes only.
        The Dispatch office an/or actual site personnel continue to be responsible for dispatch, callback, and related information.
      </Typography>
    </Box>
  );

  const handleSubmit = async (id: number) => {
    const formData = packObjForSubmit({ id });

    await submit(formData, {
      method: "put",
      action: "/current-dispatch",
    });
  }

  return (
    <CurrentDispatch showDisclaimer={showDisclaimer} setShowDisclaimer={() => setShowDisclaimer(show => !show)} isTelephoneBoard={isTelephoneBoard} data={data} handleSubmit={handleSubmit} />
  )
}